import closeTabIcon from '@lmt/unicorn-shared/app/icons/close-tab.svg';
import patientsTabIcon from '@lmt/unicorn-shared/app/icons/tab-icons/patients-default.svg';
import patientsSettingsTabIcon from '@lmt/unicorn-shared/app/icons/tab-icons/patients-settings-default.svg';
import patientsSelectedTabIcon from '@lmt/unicorn-shared/app/icons/tab-icons/patients.svg';
import patientTabIcon from '@lmt/unicorn-shared/app/icons/tab-icons/patient-default.svg';
import patientSelectedTabIcon from '@lmt/unicorn-shared/app/icons/tab-icons/patient.svg';
import calendarSelectedTabIcon from '@lmt/unicorn-shared/app/icons/tab-icons/calendar.svg';
import calendarTabIcon from '@lmt/unicorn-shared/app/icons/tab-icons/calendar-default.svg';
import dashboardTabIcon from '@lmt/unicorn-shared/app/icons/tab-icons/calendar-dashboard-default.svg';
import calendarSettingsTabIcon from '@lmt/unicorn-shared/app/icons/tab-icons/calendar-settings-default.svg';
import documentTabIcon from '@lmt/unicorn-shared/app/icons/tab-icons/document-default.svg';
import documentSelectedTabIcon from '@lmt/unicorn-shared/app/icons/tab-icons/document.svg';
import documentSettingsTabIcon from '@lmt/unicorn-shared/app/icons/tab-icons/document-settings-default.svg';
import settingsTabIcon from '@lmt/unicorn-shared/app/icons/tab-icons/settings-default.svg';
import settingsSelectedTabIcon from '@lmt/unicorn-shared/app/icons/tab-icons/settings.svg';
import defaultTabIcon from '@lmt/unicorn-shared/app/icons/tab-icons/dictionary-default.svg';
import defaultSelectedTabIcon from '@lmt/unicorn-shared/app/icons/tab-icons/dictionary.svg';
import mappingsTabIcon from '@lmt/unicorn-shared/app/icons/tab-icons/mappings-default.svg';
import mappingsSelectedTabIcon from '@lmt/unicorn-shared/app/icons/tab-icons/mappings.svg';
import customDictionaryTabIcon from '@lmt/unicorn-shared/app/icons/tab-icons/dictionary-default.svg';
import customDictionarySelectedTabIcon from '@lmt/unicorn-shared/app/icons/tab-icons/dictionary.svg';
export {
  closeTabIcon,
  patientsTabIcon,
  patientsSelectedTabIcon,
  patientTabIcon,
  patientSelectedTabIcon,
  patientsSettingsTabIcon,
  calendarTabIcon,
  calendarSelectedTabIcon,
  calendarSettingsTabIcon,
  dashboardTabIcon,
  documentTabIcon,
  documentSettingsTabIcon,
  documentSelectedTabIcon,
  settingsTabIcon,
  settingsSelectedTabIcon,
  defaultTabIcon,
  defaultSelectedTabIcon,
  mappingsTabIcon,
  mappingsSelectedTabIcon,
  customDictionaryTabIcon,
  customDictionarySelectedTabIcon,
};

//https://stackoverflow.com/a/60899201/291695
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
window.imageCache = [
  closeTabIcon,
  patientsTabIcon,
  patientsSelectedTabIcon,
  patientTabIcon,
  patientSelectedTabIcon,
  patientsSettingsTabIcon,
  calendarTabIcon,
  calendarSelectedTabIcon,
  calendarSettingsTabIcon,
  dashboardTabIcon,
  documentTabIcon,
  documentSettingsTabIcon,
  documentSelectedTabIcon,
  settingsTabIcon,
  settingsSelectedTabIcon,
  defaultTabIcon,
  defaultSelectedTabIcon,
  mappingsTabIcon,
  mappingsSelectedTabIcon,
  customDictionaryTabIcon,
  customDictionarySelectedTabIcon,
].map(preload);

function preload(image: string) {
  const imageObject = new Image();
  imageObject.src = image;
  return imageObject;
}
